module.exports = __webpack_public_path__ + "static/media/pin_specialistici_convenzionati_highlighted_old.6bad27a6.png";